
import { css } from 'lit';
export default css`
pc-hero [slot='content'] pc-story-carousel{
    --pc-story-carousel-bottom-paginator:-36px;
    position:relative;
  }
  pc-hero [slot='content'] pc-link a.link--swipe-arrow{
    color:var(--purple-indigo-light);
  }

pc-hero [slot='content'] pc-detail{
  margin-bottom:var(--spacing-4);
  display:block;
  color:var(--purple-indigo-light);
}

pc-hero [slot='content'] pc-personal-quote{
  --pc-personal-quote-border-quote:var(--purple-indigo-light);
}

pc-hero [slot='content'] pc-personal-quote [slot='content'] pc-heading{
      color:var(--primary-white);
    }

pc-hero [slot='content'] pc-personal-quote [slot='content'] pc-detail{
      color:var(--purple-indigo-light);
    }

@media (max-width: 991px){
  pc-hero [slot='content'] pc-heading{
    --heading-font-size-mobile:var(--fs-h6-mobile);
    --heading-font-size:var(--fs-h6);
  }
}

@media (min-width: 992px){
  pc-hero [slot='content'] pc-story-carousel{
    --pc-story-carousel-bottom-paginator:46px;
  }
}

@media (max-width: 1280px){
  pc-hero [slot='content'] pc-heading{
    --heading-font-size:var(--fs-h6);
  }
}
`;